import BaseModel from "@kaspernj/api-maker/build/base-model.js"
import modelClassRequire from "@kaspernj/api-maker/build/model-class-require.js"

const modelClassData = {
  "attributes": {
    "created_at": {
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      },
      "name": "created_at",
      "selected_by_default": null,
      "translated": null
    },
    "id": {
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      },
      "name": "id",
      "selected_by_default": null,
      "translated": null
    },
    "plan_resource_period_id": {
      "column": {
        "default": null,
        "name": "plan_resource_period_id",
        "null": false,
        "type": null
      },
      "name": "plan_resource_period_id",
      "selected_by_default": null,
      "translated": null
    },
    "price": {
      "column": null,
      "name": "price",
      "selected_by_default": null,
      "translated": null
    },
    "price_cents": {
      "column": {
        "default": "0",
        "name": "price_cents",
        "null": false,
        "type": "integer"
      },
      "name": "price_cents",
      "selected_by_default": null,
      "translated": null
    },
    "price_currency": {
      "column": {
        "default": "USD",
        "name": "price_currency",
        "null": false,
        "type": "string"
      },
      "name": "price_currency",
      "selected_by_default": null,
      "translated": null
    },
    "updated_at": {
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      },
      "name": "updated_at",
      "selected_by_default": null,
      "translated": null
    }
  },
  "className": "PlanResourcePeriodPrice",
  "collectionKey": "plan_resource_period_prices",
  "collectionName": "plan_resource_period_prices",
  "i18nKey": "plan_resource_period_price",
  "camelizedLower": "planResourcePeriodPrice",
  "name": "PlanResourcePeriodPrice",
  "nameDasherized": "plan-resource-period-price",
  "pluralName": "plan_resource_period_prices",
  "ransackable_associations": [
    {
      "className": "PlanResourcePeriodPrice::Audit",
      "collectionName": "plan_resource_period_price_audits",
      "foreignKey": "plan_resource_period_price_id",
      "name": "audits",
      "macro": "has_many",
      "resource_name": "PlanResourcePeriodPriceAudit",
      "through": null
    },
    {
      "className": "PlanResourcePeriodPrice::Audit",
      "collectionName": "plan_resource_period_price_audits",
      "foreignKey": "plan_resource_period_price_id",
      "name": "create_audit",
      "macro": "has_one",
      "resource_name": "PlanResourcePeriodPriceAudit",
      "through": null
    },
    {
      "className": "Currency",
      "collectionName": "currencies",
      "foreignKey": "price_currency",
      "name": "currency",
      "macro": "belongs_to",
      "resource_name": "Currency",
      "through": null
    },
    {
      "className": "PlanResourcePeriod",
      "collectionName": "plan_resource_periods",
      "foreignKey": "plan_resource_period_id",
      "name": "period",
      "macro": "belongs_to",
      "resource_name": "PlanResourcePeriod",
      "through": null
    }
  ],
  "ransackable_attributes": [
    {
      "name": "created_at",
      "column": {
        "default": null,
        "name": "created_at",
        "null": false,
        "type": "datetime"
      }
    },
    {
      "name": "id",
      "column": {
        "default": null,
        "name": "id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "plan_resource_period_id",
      "column": {
        "default": null,
        "name": "plan_resource_period_id",
        "null": false,
        "type": null
      }
    },
    {
      "name": "price_cents",
      "column": {
        "default": "0",
        "name": "price_cents",
        "null": false,
        "type": "integer"
      }
    },
    {
      "name": "price_currency",
      "column": {
        "default": "USD",
        "name": "price_currency",
        "null": false,
        "type": "string"
      }
    },
    {
      "name": "updated_at",
      "column": {
        "default": null,
        "name": "updated_at",
        "null": false,
        "type": "datetime"
      }
    }
  ],
  "ransackable_scopes": [],
  "relationships": [
    {
      "className": "PlanResourcePeriod",
      "collectionName": "plan_resource_periods",
      "foreignKey": "plan_resource_period_id",
      "name": "period",
      "macro": "belongs_to",
      "resource_name": "PlanResourcePeriod",
      "through": null
    }
  ],
  "paramKey": "plan_resource_period_price",
  "primaryKey": "id"
}

/** Frontend model for PlanResourcePeriodPrice. */
class PlanResourcePeriodPrice extends BaseModel {
  /** @returns {Record<string, any>} */
  static modelClassData() {
    return modelClassData
  }

  /** @returns {string} */
  createdAt() {
    return this.readAttributeUnderscore("created_at")
  }

  /** @returns {boolean} */
  hasCreatedAt() {
    const value = this.createdAt()

    return this._isPresent(value)
  }

  /** @returns {any} */
  id() {
    return this.readAttributeUnderscore("id")
  }

  /** @returns {boolean} */
  hasId() {
    const value = this.id()

    return this._isPresent(value)
  }

  /** @returns {any} */
  planResourcePeriodId() {
    return this.readAttributeUnderscore("plan_resource_period_id")
  }

  /** @returns {boolean} */
  hasPlanResourcePeriodId() {
    const value = this.planResourcePeriodId()

    return this._isPresent(value)
  }

  /** @returns {any} */
  price() {
    return this.readAttributeUnderscore("price")
  }

  /** @returns {boolean} */
  hasPrice() {
    const value = this.price()

    return this._isPresent(value)
  }

  /** @returns {number} */
  priceCents() {
    return this.readAttributeUnderscore("price_cents")
  }

  /** @returns {boolean} */
  hasPriceCents() {
    const value = this.priceCents()

    return this._isPresent(value)
  }

  /** @returns {string} */
  priceCurrency() {
    return this.readAttributeUnderscore("price_currency")
  }

  /** @returns {boolean} */
  hasPriceCurrency() {
    const value = this.priceCurrency()

    return this._isPresent(value)
  }

  /** @returns {string} */
  updatedAt() {
    return this.readAttributeUnderscore("updated_at")
  }

  /** @returns {boolean} */
  hasUpdatedAt() {
    const value = this.updatedAt()

    return this._isPresent(value)
  }

  /** @returns {import("./plan-resource-period.js").default | null} */
  period() {
    return this._readBelongsToReflection({reflectionName: "period"})
  }

  /** @returns {Promise<import("./plan-resource-period.js").default | null>} */
  loadPeriod() {
    if (!("planResourcePeriodId" in this)) throw new Error("Foreign key method wasn't defined: planResourcePeriodId")

    const id = this.planResourcePeriodId()
    const modelClass = modelClassRequire("PlanResourcePeriod")
    const ransack = {}

    ransack["id_eq"] = id

    return this._loadBelongsToReflection(
      {reflectionName: "period", model: this, modelClass},
      {ransack}
    )
  }
}

export default PlanResourcePeriodPrice
